import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
// import { Redirect, Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
// import { withRouter } from "react-router-dom";

import { signupHandleChange } from "../../common/actions";

import { fetchCountriesRequest, signupAction } from "../../Containers/Login/actions";
import CopyRight from "../CopyRight";
import logo from "../../images/clean-your-lists-transparent-logo.png";
import help from "../../images/help.svg";
import "../../css/animate.min.css";
import "../../css/login.css";
import leftPanelIcon from "../../images/preparing-annual-accounts.jpg";
import tickIcon from "../../images/icon-check.svg";
import { GOOGLE_TAG_CODE, LOGIN_ACTION_SUCCEEDED, SCRIPT_URL } from "../../common/constants";
import history from "..//../utility/history";
import { signupValidators, updateValidators, initValidations } from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";

import Overlay from "../../utility/overlay";
import "../../App.css";
import FormInput from "../Forms/Input";
import FormSubmit from "../Forms/Submit";
import Disclaimer from "../Forms/Disclaimer";
import { PASSWORD_MAX_LEN } from "../../utility/globalConstants";

const mapStateToProps = (state) => ({
  signupInfo: state.signupInfo,
  countriesList: state.countries.countries
});

class CreateAccount extends Component {
  constructor(props) {
    super(props);
    this.state = { showErrorSummary: false };
    this.recaptchaV2WidgetId = null;
    this.recaptchaV2ContainerRef = React.createRef();

    // Set of validators for signin form
    this.validators = signupValidators;
    initValidations(this.validators);

    /*Read values from store when routed back to the Signup page */

    // console.log("name = " + this.props.signupInfo.name);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.initPagevalidation = this.initPagevalidation.bind(this);
    this.onPrefillEmail = this.onPrefillEmail.bind(this);
    this.loadAndRenderRecaptchaV2 = this.loadAndRenderRecaptchaV2.bind(this);
  }

  initPagevalidation() {
    updateValidators(this.validators, "name", this.props.signupInfo.name);
    updateValidators(this.validators, "company", this.props.signupInfo.company);
    updateValidators(this.validators, "username", this.props.signupInfo.username);
    updateValidators(
      this.validators,
      "password",
      this.props.signupInfo.password,
      this.props.signupInfo.confirmPassword
    );
    updateValidators(
      this.validators,
      "confirmPassword",
      this.props.signupInfo.confirmPassword,
      this.props.signupInfo.password
    );
    updateValidators(this.validators, "disclaimer", this.props.signupInfo.disclaimer);
    updateValidators(this.validators, "country", this.props.signupInfo.country);
  }
  handleChange(event) {
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    this.props.dispatch(signupHandleChange(event.target.name, value));
    updateValidators(this.validators, event.target.name, value);
  }
  onPrefillEmail(email) {
    this.props.dispatch(signupHandleChange("username", email));
    updateValidators(this.validators, "username", email);
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ showErrorSummary: true });
    this.initPagevalidation();
    if (this.validators.errorSummary.length == 0) {
      console.log("form is valid");
      const { name, username, password, company, country, requireRecaptchaV2 } = this.props.signupInfo;
      let idmkmdigid = document.getElementById("idmkmdigid").value;

      if (requireRecaptchaV2) {
        const recaptchaV2SiteKey = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY;
        if (!recaptchaV2SiteKey || !window.grecaptcha || this.recaptchaV2WidgetId == null) {
          toastr.error("Error", "Please complete the verification below and try again.");
          return;
        }
        const v2Token = window.grecaptcha.getResponse(this.recaptchaV2WidgetId);
        if (!v2Token) {
          toastr.error("Error", "Please complete the \"I'm not a robot\" verification.");
          return;
        }
        this.props.dispatch(signupAction({
          name,
          username,
          password,
          company,
          country,
          idmkmdigid,
          recaptchaV2Token: v2Token
        }));
        return;
      }

      // Execute reCAPTCHA v3
      const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
      if (window.grecaptcha && recaptchaSiteKey) {
        window.grecaptcha.ready(async () => {
          try {
            const token = await window.grecaptcha.execute(recaptchaSiteKey, { action: 'SIGNUP' });
            // Include reCAPTCHA token in signup payload
            this.props.dispatch(signupAction({
              name,
              username,
              password,
              company,
              country,
              idmkmdigid,
              recaptchaToken: token
            }));
          } catch (error) {
            console.error("reCAPTCHA error:", error);
            toastr.error("Error", "reCAPTCHA verification failed. Please try again.");
          }
        });
      } else {
        // Fallback if reCAPTCHA is not loaded
        console.warn("reCAPTCHA not loaded, proceeding without token");
        this.props.dispatch(signupAction({ name, username, password, company, country, idmkmdigid }));
      }
    } else {
      console.log("form is Invalid");
    }
  }
  loadAndRenderRecaptchaV2() {
    const recaptchaV2SiteKey = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY;
    if (!recaptchaV2SiteKey || !this.recaptchaV2ContainerRef.current) return;
    if (this.recaptchaV2WidgetId != null) return;
    if (window.grecaptcha && typeof window.grecaptcha.render === "function") {
      try {
        this.recaptchaV2WidgetId = window.grecaptcha.render(this.recaptchaV2ContainerRef.current, {
          sitekey: recaptchaV2SiteKey
        });
      } catch (e) {
        console.error("reCAPTCHA v2 render error:", e);
      }
      return;
    }
    const scriptId = "recaptcha-v2-script";
    if (document.getElementById(scriptId)) {
      window.onRecaptchaV2Ready = () => this.loadAndRenderRecaptchaV2();
      return;
    }
    window.onRecaptchaV2Ready = () => {
      this.loadAndRenderRecaptchaV2();
      window.onRecaptchaV2Ready = null;
    };
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaV2Ready&render=explicit`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  componentDidUpdate(prevProps) {
    const requireV2 = this.props.signupInfo && this.props.signupInfo.requireRecaptchaV2;
    const hadRequireV2 = prevProps.signupInfo && prevProps.signupInfo.requireRecaptchaV2;
    if (requireV2 && !hadRequireV2) {
      this.setState({}, () => {
        setTimeout(() => this.loadAndRenderRecaptchaV2(), 100);
      });
    }
  }

  componentDidMount() {
    // let e, t;
    // e = document.createElement("script");
    // e.type = "text/javascript";
    // e.id = "tracker-script";
    // e.async = !0;
    // e.defer = !0;
    // e.src = SCRIPT_URL;
    // t = document.getElementsByTagName("head")[0];
    // // Adding as first child for head
    // t.prepend(e);
    // if (GOOGLE_TAG_CODE) {
    //   window["dataLayer"] = [];
    //   window["dataLayer"].push({
    //     "gtm.start": new Date().getTime(),
    //     event: "gtm.js",
    //   });
    //   var firstScriptTag = document.getElementsByTagName("script")[0];
    //   var scriptTag = document.createElement("script");
    //   var conversionScript = document.createElement("script");
    //   scriptTag.async = true;
    //   scriptTag.id = "gtm-script";
    //   conversionScript.id = "gtag-conversion-report";
    //   scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_CODE}`;
    //   firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
    //   conversionScript.innerText = `function gtag_report_conversion(url){var callback = function (){if(typeof(url) != 'undefined'){window.location = url;}};gtag('event', 'conversion',{'send_to': 'AW-1070812079/_A-TCNT_8okDEK-Xzf4D','event_callback': callback});return false;}`
    //   let body = document.getElementsByTagName("body");
    //   body = body[0];
    //   body.insertAdjacentHTML(
    //     "afterbegin",
    //     "<noscript id='n-script'></noscript>"
    //   );
    //   let iFrame = document.createElement("iframe");
    //   iFrame.src = `https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_CODE}`;
    //   iFrame.style.cssText = "height=0;width=0;display:none;visibility:hidden";
    //   document.getElementById("n-script").appendChild(iFrame);
    //   t.appendChild(conversionScript);
    document.body.classList.add("bgColor");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).includes("email")) {
      this.onPrefillEmail(params["email"]);
    }
    // }

    // Load reCAPTCHA v3 script
    const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (recaptchaSiteKey && !document.getElementById("recaptcha-script")) {
      const script = document.createElement("script");
      script.id = "recaptcha-script";
      script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    // dispatching action to fetch countries
    this.props.dispatch(fetchCountriesRequest());
  }
  componentWillUnmount() {
    // var element = document.getElementById("tracker-script");
    // element.parentNode.removeChild(element);
    // var element1 = document.getElementById("gtm-script");
    // element1.parentNode.removeChild(element1);
    // const element2 = document.getElementById("n-script");
    // element2.parentNode.removeChild(element2);
    // const element3 = document.getElementById("gtag-conversion-report");
    // element3.parentNode.removeChild(element3);
    document.body.classList.remove("bgColor");
    // Clean up reCAPTCHA script if needed
    const recaptchaScript = document.getElementById("recaptcha-script");
    if (recaptchaScript) {
      recaptchaScript.remove();
    }
    const recaptchaV2Script = document.getElementById("recaptcha-v2-script");
    if (recaptchaV2Script) {
      recaptchaV2Script.remove();
    }
    this.recaptchaV2WidgetId = null;
  }

  render() {
    return (
      <div className="signup-container">
        {this.state.showErrorSummary ? <ValidationSummary errorMsg={this.validators.errorSummary} /> : null}
        {this.props.signupInfo.btnDisabled ? <Overlay /> : null}
        <div className="section-image">
          <div
            style={{
              position: "absolute",
              top: 100,
              left: 50,
            }}
          >
            <div style={{ lineHeight: 1.2 }}>
              <p style={{ fontSize: 35, marginBottom: 0 }}>
                <b>Sign up for free.</b>
              </p>
              <p style={{ fontSize: 35, marginBottom: 0 }}>
                <b>
                  No credit card <br /> required.
                </b>
              </p>
            </div>
            <div style={{ display: "flex" }}>
              <img src={tickIcon} style={{ marginTop: 40, marginRight: 10 }} />
              <p
                style={{
                  color: "black",
                  fontSize: 16,
                  marginTop: 40,
                  marginBottom: 0,
                }}
              >
                Avoid spam complaints and phishing <br /> scams
              </p>
            </div>
            <div style={{ display: "flex" }}>
              <img src={tickIcon} style={{ marginRight: 10 }} />
              <p style={{ color: "black", fontSize: 16, marginBottom: 0 }}>Decrease hard bounces</p>
            </div>
            <div style={{ display: "flex" }}>
              <img src={tickIcon} style={{ marginRight: 10 }} />
              <p style={{ color: "black", fontSize: 16, marginBottom: 0 }}>
                Increase deliverability rates with <br /> 98% accuracy
              </p>
            </div>
            <div style={{ display: "flex" }}>
              <img src={tickIcon} style={{ marginRight: 10 }} />
              <p style={{ color: "black", fontSize: 16, marginBottom: 0 }}>Detect GDPR IP addresses</p>
            </div>
          </div>
        </div>
        <div className="section-form">
          <form className="signup-frm" onSubmit={this.handleSubmit}>
            {this.state.showErrorSummary ? <ValidationSummary errorMsg={this.validators.errorSummary} /> : null}
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <h1>
                <a href="https://cleanyourlists.com/" target="_blank">
                  <img src={logo} alt="logo" width="320" />
                </a>
              </h1>
              <p style={{ fontSize: 35, paddingTop: 65, marginBottom: 0 }}>
                <b>Get Started</b>
              </p>
              <p style={{ fontSize: 15 }}>
                Already have an account?
                <Link to="/login" style={{ textDecoration: "underline", color: "#52a792" }}>
                  {" "}
                  Login
                </Link>
              </p>
              <input type="hidden" name="idmkmdigid" id="idmkmdigid" />
              <FormInput
                placeholder="Full Name *"
                onChange={this.handleChange}
                name="name"
                styles={{ marginBottom: 20, width: "80%" }}
                value={this.props.signupInfo.name}
              />
              <FormInput
                type={"email"}
                placeholder="Work Email *"
                onChange={this.handleChange}
                styles={{ marginBottom: 2, width: "80%" }}
                suggestionText="* It's necessary to submit your work email to receive 1,500 free credits."
                value={this.props.signupInfo.username}
                name="username"
              />
              <FormInput
                type="password"
                placeholder="Password *"
                onChange={this.handleChange}
                styles={{ marginBottom: 20, width: "80%" }}
                name="password"
                value={this.props.signupInfo.password}
                maxLength={PASSWORD_MAX_LEN}
              />
              <FormInput
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password *"
                styles={{ marginBottom: 20, width: "80%" }}
                value={this.props.signupInfo.confirmPassword}
                onChange={this.handleChange}
                maxLength={PASSWORD_MAX_LEN}
              />
              <FormInput
                placeholder="Company Name *"
                styles={{ marginBottom: 20, width: "80%" }}
                onChange={this.handleChange}
                value={this.props.signupInfo.company}
                name="company"
              />
              <FormInput
                type="select"
                placeholder="Country *"
                styles={{ marginBottom: 20, width: "80%" }}
                onChange={this.handleChange}
                value={this.props.signupInfo.country}
                name="country"
                options={[
                  { value: "", label: "Select Country *" },
                  ...this.props.countriesList
                ]}
              />
              <Disclaimer onChange={this.handleChange} value={this.props.signupInfo.disclaimer} name="disclaimer" />
              {this.props.signupInfo.requireRecaptchaV2 && (
                <div style={{ marginBottom: 16, display: "flex", justifyContent: "center", flexDirection: "column", width: "80%", margin: "0 auto" }}>
                  <div ref={this.recaptchaV2ContainerRef} id="recaptcha-v2-container" style={{ display: "inline-block" }}/>
                  <p style={{ fontSize: 13, marginTop: 8, textAlign: "left" }}>
                    Please complete the verification above to continue.
                  </p>
                </div>
              )}
              <FormSubmit
                value="Sign Up"
                styles={{
                  marginTop: 5,
                  marginBottom: 10,
                  color: "#fff",
                  width: "80%",
                  background: "#272759",
                }}
              />
              <p className="signupTerms">
                By clicking the "Sign Up" button you agree to our{" "}
                <a
                  style={{ textDecoration: "underline" }}
                  href="https://www.mirabeltechnologies.com/privacy-statement/"
                  target="_blank"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  style={{ textDecoration: "underline" }}
                  href="https://www.mirabeltechnologies.com/terms-of-service/"
                  target="_blank"
                >
                  Terms of Service
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(CreateAccount);

CreateAccount.propTypes = {
  signupInfo: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  dispatch: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Login/CreateAccount.js